import React, { useState } from 'react'
import './Navbar.css'
import { NavLink} from 'react-router-dom'
import {FaBars} from 'react-icons/fa'
import {FaTimes} from 'react-icons/fa'
const Navbar=()=> {
   const [isMobile,setIsMobile]=useState(false)
  return (
    <div className='navbar' >
      <button className='mobile-icon' onClick={()=>setIsMobile(!isMobile)}>
      {isMobile?<FaTimes/>:<FaBars/>}
      </button>
    <div className={isMobile?"navbar__mobile":"navbar__list"}> 
    <div className={isMobile?"mobile-line":"noneLine"}></div>     
     <ul onClick={()=>setIsMobile(false)}>     
       <li><NavLink to="/yangiliklar">Yangiliklar </NavLink></li>
       <li><NavLink to="/tuzilma" > Tuzilma </NavLink> </li>
       <li><NavLink to="/madaniy" >  Madaniy-ma'rifiy </NavLink></li>
       <li><NavLink to="/media/photo" > Media </NavLink></li>
       <li><NavLink to="/fakultet" > Fakultet haqida </NavLink></li>
       <li><NavLink to="/aloqa" > Aloqa </NavLink></li>
      </ul>
    </div>
    <div className='navbar__form'>
       <input type="text" className='navbar__form-search' placeholder="Qidiruv" />
       
    </div>
    </div>
    
  )
}

export default Navbar
